import { REMOVE_WALK } from '../constants/index';
import { RemoveWalkState, RemoveWalkActions } from '../types/RemoveWalkTypes'

const initialState: RemoveWalkState = {
  id: 0
}

const removeWalkReducer = (state = initialState, action: RemoveWalkActions) => {
  const payload = action.payload
  switch(action.type){

    case REMOVE_WALK:
      return {
        ...state,
        id: payload
      }

    default: 
      return state
  }
}

export default removeWalkReducer;